import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const BoxScoresWidgetAsyncComponent = AsyncComponent(async () => import('./box-scores-widget' /* webpackChunkName: "box-scores-widget" */ ));

export const BoxScoresWidgetAsync = (props) => {
  return (
    <ErrorBoundaryWrapper isMandatory>
      <React.Suspense fallback={<div/>}>
        <BoxScoresWidgetAsyncComponent {...props}/>
      </React.Suspense>
    </ErrorBoundaryWrapper>
  )
};

